import Menu from './components/Menu';
import WhmcsServersConfigTable from './shortcodes/WhmcsServersConfigTable'
import Vdc from './products/Vdc'

jQuery(document).ready(function ($) {
  const shareLink = $('.share__link');

  if (shareLink) {
    shareLink.on('click', function () {
      const linkHref = $(this).data('share-link');
      const shareAlert = $(this).prev('.share__alert');
      shareAlert.addClass('share__alert--active');
      setTimeout(function () {
        shareAlert.removeClass('share__alert--active');
      }, 3000);
      navigator.clipboard.writeText(linkHref);
    });
  }

	$('.lang-item-ru').remove();
});

new Menu();
new Vdc()

const ssl = document.querySelector('.ssl-wrapper');
ssl?.addEventListener('click', e => {
  if(e.target.closest('.ssl-buy')) {
    e.stopPropagation();
  }
})

new WhmcsServersConfigTable();
